import { Modal, SvgIcon, useIsWindowBiggerThan } from '@bob/library'
import { WithBrand } from '@websrc/App/Components/WithBrand'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import clsx from 'clsx'
import { breakpoints, button, sidebar, sidebarToggle, styles, typography } from 'leds'
import React, { FC, useEffect, useLayoutEffect, useState } from 'react'

import { SidebarMenu } from './Menu/SidebarMenu'
import { SidebarProps } from './SidebarProps'

export const Sidebar: FC<SidebarProps> = (props) => {
  const [expand, setExpand] = useState(true)
  const windowIsLarge = useIsWindowBiggerThan(breakpoints.l)
  const windowIsSmall = !useIsWindowBiggerThan(breakpoints.m)
  const t = useStaticText()

  const productLabel = props.selectedProduct
    ? `${props.selectedProduct.productLine} ${props.selectedProduct.segment}`
    : t.search.products

  useEffect(() => {
    const hashChangeListener = () => {
      if (windowIsSmall) {
        setExpand(false)
      }
    }

    window.addEventListener('hashchange', hashChangeListener)

    return () => window.removeEventListener('hashchange', hashChangeListener)
  }, [windowIsSmall])

  useLayoutEffect(() => {
    setExpand(windowIsLarge)
  }, [windowIsLarge])

  const toggleSidebar = () => {
    setExpand(!expand)
  }

  return (
    <div
      className={sidebar({ state: expand ? 'expanded' : 'collapsed' })}
      data-testid={`expanded-${expand}`}
    >
      <div
        className={clsx(
          sidebarToggle({ state: expand ? 'expanded' : 'collapsed' }),
          styles({
            display: 'flex',
            height: 'full',
            paddingX: 16,
            paddingY: 0,
            alignItems: 'center',
          })
        )}
      >
        <div className={styles({ display: { screenXS: 'block', screenM: 'none' } })}>
          <p
            className={clsx(
              typography({ size: 'xs', color: 'grey', lineHeightReset: true }),
              styles({ margin: 0 })
            )}
          >
            <WithBrand title={'{brand}'} />
          </p>
          <p
            className={clsx(
              styles({ margin: 0 }),
              typography({ size: 'md', lineHeightReset: true })
            )}
          >
            {productLabel}
          </p>
        </div>
        <button
          aria-expanded={expand}
          className={button({ type: 'icon' })}
          data-testid={`expand-button`}
          onClick={toggleSidebar}
        >
          <SvgIcon
            className={
              expand
                ? styles({
                    transform: { screenXS: 'rotate90', screenM: 'rotate0' },
                    transition: 200,
                  })
                : styles({
                    transform: { screenXS: 'rotate270', screenM: 'rotate180' },
                    transition: 200,
                  })
            }
            color={'black'}
            name={'ARROW_LEFT'}
            size={12}
            strokeWidth={3}
          />
        </button>
      </div>
      {!windowIsSmall && <SidebarMenu {...props} expand={expand} onToggleSidebar={toggleSidebar} />}
      {expand && windowIsSmall && (
        <Modal
          className={styles({
            backgroundColor: 'grey1',
          })}
          closeCallback={() => setExpand(false)}
          customContent={true}
          fullWidth={true}
          position={'center'}
          stickyClose={true}
        >
          <SidebarMenu {...props} expand={true} />
        </Modal>
      )}
    </div>
  )
}
